import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import * as actions from '@appStore/managers/actions';
import { ManagerCustomersActionTypes, ManagerCustomersUsersLoadData, ManagerCustomerUsersLoadData } from '@appStore/managers/actions';
import { ManagerService } from '@appStore/managers/services';
import { Router } from '@angular/router';

@Injectable()
export class ManagerCustomersEffects {
  constructor(private managerService: ManagerService, private actions$: Actions, private router: Router) {}

  loadMyManagerCustomerUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.ManagerCustomerUsersLoadData),
      exhaustMap((action: ManagerCustomerUsersLoadData) => {
        return this.managerService
          .getMyManagerCustomerUsers(action.payload.managerCompanyId, action.payload.customerId)
          .pipe(
            map(users => new actions.ManagerCustomerUsersLoadSuccess(users)),
            catchError(error => of(new actions.ManagerCustomerUsersLoadFail(error)))
          );
      })
    );
  });
  
  loadMyManagerCustomersUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.ManagerCustomersUsersLoadData),
      exhaustMap((action: ManagerCustomersUsersLoadData) => {
        return this.managerService
          .getMyManagerCustomersUsers(action.payload.managerCompanyId, action.payload.customerIds)
          .pipe(
            map(users => new actions.ManagerCustomersUsersLoadSuccess(users)),
            catchError(error => of(new actions.ManagerCustomersUsersLoadFail(error)))
          );
      })
    );
  });
  
  loadManagerCustomerMeteringPoints$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.ManagerCustomerMeteringPointsLoad),
      map((action: actions.ManagerCustomerMeteringPointsLoad) => action.payload),
      exhaustMap(indata =>
        this.managerService.getManagerCustomerMeteringPoints(indata).pipe(
          map(meteringPoints => new actions.ManagerCustomerMeteringPointsLoadSuccess(meteringPoints)),
          catchError(error => of(new actions.ManagerCustomerMeteringPointsLoadFail(error)))
        )
      )
    );
  });
  
  addManagerCompanyUsersToCustomer$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.BulkAddManagerUsersToCustomer),
      map((action: actions.BulkAddManagerUsersToCustomer) => action.payload),
      exhaustMap(users =>
        this.managerService.bulkAddManagerCompanyUsersToCustomer(users).pipe(
          map(items => new actions.BulkAddManagerUsersToCustomerSuccess(items)),
          catchError(error => of(new actions.BulkAddManagerUsersToCustomerFail(error)))
        )
      )
    );
  });
  
  lockManagerCustomerUsersForUpdate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.LockManagerCustomerUsersForUpdate),
      map((action: actions.LockManagerCustomerUsersForUpdate) => action.payload),
      exhaustMap(users =>
        this.managerService.lockManagerCustomerUsersForUpdate(users).pipe(
          map(item => new actions.LockManagerCustomerUsersForUpdateSuccess(item)),
          catchError(error => of(new actions.LockManagerCustomerUsersForUpdateFail(error)))
        )
      )
    );
  });
  
  updateManagerCustomerUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.UpdateManagerCustomerUser),
      map((action: actions.UpdateManagerCompanyUser) => action.payload),
      exhaustMap(user =>
        this.managerService.updateManagerCustomerUser(user).pipe(
          map(item => new actions.UpdateManagerCustomerUserSuccess(item)),
          catchError(error => of(new actions.UpdateManagerCustomerUserFail(error)))
        )
      )
    );
  });
  
  removeManagerCustomerUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.ManagerCustomerUserRemove),
      map((action: actions.ManagerCustomerUserRemove) => action.payload),
      exhaustMap(user =>
        this.managerService.removeManagerCustomerUser(user).pipe(
          map(() => new actions.ManagerCustomerUserRemoveSuccess(user)),
          catchError(error => of(new actions.ManagerCustomerUserRemoveFail(error)))
        )
      )
    );
  });
  
  removeManagerCustomer$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ManagerCustomersActionTypes.ManagerCustomerRemove),
      map((action: actions.ManagerCustomerRemove) => action.payload),
      exhaustMap(managerCustomer =>
        this.managerService.removeManagerCustomer(managerCustomer).pipe(
          map(() => new actions.ManagerCustomerRemoveSuccess(managerCustomer)),
          catchError(error => of(new actions.ManagerCustomerRemoveFail(error)))
        )
      )
    );
  });
}
